// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.luxury-input[data-v-a82ee8c0] {
  background: #eee;
}
.vehicle_input[data-v-a82ee8c0] {
  border-radius: 5px;
  border: 1px solid #ddd;
  width: 100%;
  height: 40px;
  padding: 10px 0px 10px 40px;
}
.autocomplete_vehicles[data-v-a82ee8c0] {
  background-color: #fff;
  z-index: 20;
  width: 100%;
}
.vehicles-dropdown[data-v-a82ee8c0] {
  width: 100%;
  list-style: none;
  margin: 0px;
  padding: 0px;
  height: 250px;
  overflow-y: auto;
}
.set-height .vehicles-dropdown[data-v-a82ee8c0] {
  height: 52px;
}
.vehicles-dropdown li[data-v-a82ee8c0] {
  border-bottom: 1px solid #e0e0e0;
  background-color: #f5f5f5;
}
.vehicles-dropdown li a[data-v-a82ee8c0] {
  padding: 10px;
  width: 100%;
  color: #555;
}
.autocomplete_vehicles[data-v-a82ee8c0]::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.autocomplete_vehicles[data-v-a82ee8c0]::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
.vehicles-dropdown li a[data-v-a82ee8c0]:hover {
  text-decoration: none;
  background-color: #ddd;
}
.dropdown-image[data-v-a82ee8c0] {
  width: 55px;
  height: 40px;
}
.dropdown-text[data-v-a82ee8c0] {
  font-size: 12px;
  margin-left: 10px;
}
.search-icon[data-v-a82ee8c0] {
  position: absolute;
  top: 8px;
  left: 15px;
  padding: 3px;
  border-radius: 3px;
  color: #fff;
}
.vehicles-dropdown li.focus[data-v-a82ee8c0] {
  text-decoration: none;
  background-color: #ddd;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SearchMenu/InventoryVehicleSearch/InventoryVehicleSearch.vue"],"names":[],"mappings":";AAkCA;EACE,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,YAAY;AACd;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;AACb;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,oDAAoD;AACtD;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AAEA;EACE,WAAW;EACX,YAAY;AACd;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":["<template>\r\n  <div v-click-outside=\"removeSearch\">\r\n    <div :class=\"{ 'luxury-input p-3': isluxury }\">\r\n      <div style=\"width: 100%\">\r\n        <div class=\"position-relative\">\r\n          <label for=\"search\" class=\"w-100 mb-0\" title=\"search box\">\r\n            <input type=\"text\" id=\"search\" class=\"vehicle_input rounded-inputs website-input-box\"\r\n              @input=\"searchVehicles($event)\" @keyup.esc=\"removeSearch()\" @keyup.enter=\"navigateToFirstVehicle()\"\r\n              v-model=\"searchkey\" @keydown=\"selectSearch\" :placeholder=\"setPlaceholderText\" maxlength=\"50\" />\r\n\r\n            <em class=\"primaryicon-search search-icon color-secondary\"></em>\r\n          </label>\r\n          <div class=\"autocomplete_vehicles\" :class=\"[vehiclesdata.length == 1 ? 'set-height' : '']\" :style=\"boxstyle\">\r\n              <ul v-if=\"vehiclesdata.length\" class=\"vehicles-dropdown\">\r\n                <li ref=\"vehicleItems\" v-for=\"(value, index) in vehiclesdata\" :key=\"index\"\r\n                  @click=\"searchItemClick(index)\" :class=\"{ focus: index === focus }\">\r\n                  <a :href=\"`${baseUrl}${value.link}`\" class=\"d-inline-block p-3\">\r\n                    <div class=\"d-flex align-items-center\">\r\n                      <div class=\"dropdown-text\">{{ value.vehcileName }}</div>\r\n                    </div>\r\n                  </a>\r\n                </li>\r\n              </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<script type=\"text/javascript\" src=\"./InventoryVehicleSearch.js\"></script>\r\n\r\n\r\n<style scoped>\r\n.luxury-input {\r\n  background: #eee;\r\n}\r\n\r\n.vehicle_input {\r\n  border-radius: 5px;\r\n  border: 1px solid #ddd;\r\n  width: 100%;\r\n  height: 40px;\r\n  padding: 10px 0px 10px 40px;\r\n}\r\n\r\n.autocomplete_vehicles {\r\n  background-color: #fff;\r\n  z-index: 20;\r\n  width: 100%;\r\n}\r\n\r\n.vehicles-dropdown {\r\n  width: 100%;\r\n  list-style: none;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  height: 250px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.set-height .vehicles-dropdown {\r\n  height: 52px;\r\n}\r\n\r\n.vehicles-dropdown li {\r\n  border-bottom: 1px solid #e0e0e0;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.vehicles-dropdown li a {\r\n  padding: 10px;\r\n  width: 100%;\r\n  color: #555;\r\n}\r\n\r\n.autocomplete_vehicles::-webkit-scrollbar {\r\n  -webkit-appearance: none;\r\n  width: 7px;\r\n}\r\n\r\n.autocomplete_vehicles::-webkit-scrollbar-thumb {\r\n  border-radius: 4px;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.vehicles-dropdown li a:hover {\r\n  text-decoration: none;\r\n  background-color: #ddd;\r\n}\r\n\r\n.dropdown-image {\r\n  width: 55px;\r\n  height: 40px;\r\n}\r\n\r\n.dropdown-text {\r\n  font-size: 12px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.search-icon {\r\n  position: absolute;\r\n  top: 8px;\r\n  left: 15px;\r\n  padding: 3px;\r\n  border-radius: 3px;\r\n  color: #fff;\r\n}\r\n\r\n.vehicles-dropdown li.focus {\r\n  text-decoration: none;\r\n  background-color: #ddd;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
